module.exports = __webpack_public_path__ + "static/media/key.c0cfa625.png";